import { Grid, Paper, Tooltip, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { GridDirection } from '@mui/material/Grid'
import { SvgIconProps } from '@mui/material/SvgIcon'
import { CommentOutline } from 'mdi-material-ui'
import * as React from 'react'

const StyledPaper = styled(Paper)(({ theme }) => ({
  margin: 4,
  padding: theme.spacing(2),
  paddingTop: 10,
  border:
    theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.12)' : undefined,
}))

interface ICardWithTitleProps {
  title: string
  titleComponent?: JSX.Element
  isTitleComponentPushedRight?: boolean
  icon?: React.ComponentType<SvgIconProps>
  formGridDirection?: GridDirection
  formGridAlignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline'
  headerStyle?: React.CSSProperties
  fullHeight?: boolean
  onClick?: () => void
  subTitle?: React.ReactNode
  subTitleInfo?: string
  children?: React.ReactNode
}

const CardWithTitle: React.FC<ICardWithTitleProps> = ({
  children,
  formGridAlignItems = 'center',
  formGridDirection = 'row',
  icon,
  isTitleComponentPushedRight = false,
  title,
  titleComponent,
  headerStyle = {},
  fullHeight,
  onClick,
  subTitle,
  subTitleInfo,
}) => {
  const componentStyles = () => {
    if (isTitleComponentPushedRight) {
      return {
        marginLeft: 'auto',
      } as React.CSSProperties
    } else {
      return undefined
    }
  }

  const Icon = icon

  const cardHeader = (
    <Grid
      container
      item
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        height: 60,
        marginBottom: 1,
        marginLeft: 1,
        ...headerStyle,
      }}
      xs={12}
      onClick={onClick}
      style={{ marginLeft: 0 }} // this is needed because material UI grid spacing applies -8px margin.
    >
      <Grid item>{Icon && <Icon style={{ fontSize: '32px' }} color="secondary" />}</Grid>
      <Grid item sx={{ fontSize: '20px', paddingTop: '4px' }}>
        {title}
      </Grid>
      {subTitle && (
        <>
          {typeof subTitle === 'string' ? (
            <Typography display="inline" variant="subtitle2">
              &nbsp;{subTitle}&nbsp;&nbsp;
            </Typography>
          ) : (
            subTitle
          )}
          {subTitleInfo && (
            <Tooltip title={subTitleInfo}>
              <span>
                <CommentOutline fontSize="small" />
              </span>
            </Tooltip>
          )}
        </>
      )}
      {titleComponent && (
        <Grid item style={componentStyles()}>
          {titleComponent}
        </Grid>
      )}
    </Grid>
  )

  return (
    <StyledPaper style={{ height: fullHeight ? '100%' : 'auto' }}>
      <Grid container direction="column" spacing={2}>
        {cardHeader}
        <Grid
          container
          item
          direction={formGridDirection}
          xs={12}
          spacing={1}
          alignItems={formGridAlignItems}
          style={{ marginLeft: 0 }} // this is needed because material UI grid spacing applies -8px margin.
        >
          {children}
        </Grid>
      </Grid>
    </StyledPaper>
  )
}

export default CardWithTitle
